import gql from 'graphql-tag';

export default gql`
  mutation removeByIdLessonTemplateMutation($_id: MongoID!) {
    removeByIdLessonTemplateMutation(_id: $_id) {
      recordId
    }
  }
`;
